import * as ProfilePageActions from './profile-page.actions';
import * as UserAPIActions from './user-api.actions';

export { ProfilePageActions, UserAPIActions };
